import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
  },

  contentContainer: ({ isStory }) => ({
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: isStory ? 'flex-start' : 'center',
    padding: '1rem',
    maxHeight: '249px',
  }),
  coachImage: {
    height: '78px',
    width: '78px',
    border: `1px solid ${theme.palette.grey.warm}`,
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    justifyContent: 'center',
    objectFit: 'cover',
    marginRight: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      height: '48px',
      width: '48px',
    },
  },
  iconMarker: {
    marginLeft: '-5px',
  },
  location: {
    fontWeight: 400,
    fontSize: '12px',
  },
  locationIcon: {
    fontSize: '0.8rem',
    marginBottom: '0.35em',
    marginRight: '0.25em',
  },
  coachName: {
    textAlign: 'center',
    color: '#1D2758',
    fontSize: '20px',
    marginBottom: '0.3rem',
  },
  ctaContainer: {
    padding: '0 1rem 1rem 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  meetCoachButton: {
    marginBottom: '1.25rem',
  },
  smallFont: {
    fontSize: '12px',
    padding: '0 0 0 0.5rem',
    '& .MuiButton-endIcon': {
      marginLeft: '4px',
    },
  },
  contactButton: ({ isTablet }) => ({
    color: theme.palette.blue.main,
    border: isTablet ? `1px solid ${theme.palette.blue.main}` : 'none',
  }),
  bookNowButton: ({ memberType }) => ({
    backgroundColor: memberType
      ? theme.palette.secondary.light
      : '#FAFAFA',
    color: memberType
      ? theme.palette.common.white
      : theme.palette.secondary.light,
    border: `1px solid ${theme.palette.secondary.light}`,
    '&:hover': {
      backgroundColor: memberType
        ? theme.palette.secondary.main
        : theme.palette.blue.light100,
      color: memberType
        ? theme.palette.common.white
        : theme.palette.blue.main,
    },
  }),
}))

export default useStyles
